export const fmtUsd = (n: number): string =>
    n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtUnitUsd = (n: number): string =>
    n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 });

export const fmtDollar = (n: number, maxDecimals = 2): string => {
    const formatter = maxDecimals > 2 ? fmtUnitUsd : fmtUsd;
    if (n < 0) return `-$${formatter(Math.abs(n))}`;
    return `$${formatter(n)}`;
};
